
class Pagination {

    renderPagination(totalPages, currentPage, callback) {
      const paginationContainer = document.querySelector('.js-listing-pagination-container') as HTMLElement
      paginationContainer.innerHTML = ''
      if (totalPages <= 1) {
        return (paginationContainer.innerHTML = '')
      }
      paginationContainer.className='js-listing-pagination-container py-8 lg:px-6'
      let beforePage = currentPage - 1
      let afterPage = currentPage + 1
      const createPageNumber = (i) => {
        const pageBtn = document.createElement('button')
        pageBtn.textContent = i
        pageBtn.className = 'page-numbers'
        pageBtn.addEventListener('click', () => callback(i))
        if (i === currentPage) {
          pageBtn.className = 'page-numbers current'
        }
        return pageBtn
      }
      const createDotElement = () => {
        const dotElement = document.createElement('span')
          dotElement.textContent = '...'
          dotElement.className = 'page-numbers'
          return dotElement
      }
      // Render previous page button
      const prevBtn = document.createElement('button')
      prevBtn.className =
        'raise-next-prev-btn raise-previous-page raise-disable-button'
      if (currentPage !== 1) {
        prevBtn.className = 'raise-next-prev-btn raise-previous-page'
        prevBtn.addEventListener('click', () =>
          callback(currentPage - 1)
        )
      }
      paginationContainer.appendChild(prevBtn)
      if (currentPage > 2 && totalPages > 5) {
        paginationContainer.appendChild(createPageNumber(1))
        if (currentPage > 3) {
          paginationContainer.appendChild(createDotElement())
        }
      }
      if (currentPage == totalPages && totalPages > 5) {
        beforePage = beforePage - 2
      } else if (currentPage == totalPages - 1 && totalPages > 5) {
        beforePage = beforePage - 1
      }
      if (currentPage == 1) {
        afterPage = afterPage + 2
      } else if (currentPage == 2) {
        afterPage = afterPage + 1
      }
      if (totalPages <= 5) {
        beforePage = 1
        afterPage = totalPages
      }
      for (let pLength = beforePage; pLength <= afterPage; pLength++) {
        if (pLength > totalPages) {
          continue
        }
        if (pLength == 0) {
          pLength = pLength + 1
        }
        paginationContainer.appendChild(createPageNumber(pLength))
      }
      if (currentPage < totalPages - 1 && totalPages > 5) {
        if (currentPage < totalPages - 2) {
          paginationContainer.appendChild(createDotElement())
        }
        paginationContainer.appendChild(createPageNumber(totalPages))
      }
      // Render next page button
      const nextBtn = document.createElement('button') as HTMLButtonElement
      nextBtn.className = 'raise-next-prev-btn raise-next-page raise-disable-button'
      if (currentPage < totalPages) {
        nextBtn.className = 'raise-next-prev-btn raise-next-page '
        nextBtn.addEventListener('click', () =>
          callback(currentPage + 1)
        )
      }
      paginationContainer.appendChild(nextBtn)
    }
  }
  
  export default Pagination
  